import React from "react";

export type ModoTema = "light" | "dark";

export const CHAVE_MODO_TEMA = "conciliador.modoTema";

export const lerModoTema = (): ModoTema => {
  try {
    return window.localStorage.getItem(CHAVE_MODO_TEMA) === "dark" ? "dark" : "light";
  } catch (e) {
    return "light";
  }
};

export const gravarModoTema = (modo: ModoTema) => {
  try {
    window.localStorage.setItem(CHAVE_MODO_TEMA, modo);
  } catch (e) {}
};

export const proximoModo = (modo: ModoTema): ModoTema => (modo === "dark" ? "light" : "dark");

export const ModoTemaContext = React.createContext<{ modo: ModoTema; alternarModo: () => void }>({
  modo: "light",
  alternarModo: () => {},
});
